import { render, staticRenderFns } from "./cooperativeDiagnosis.vue?vue&type=template&id=cc19e1c8"
import script from "./cooperativeDiagnosis.vue?vue&type=script&lang=js"
export * from "./cooperativeDiagnosis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports